/*************************
 Quick add dialog listeners
 **************************/

// this will get re-run often as the quick add or collections update
function quickAddListeners() {
    // inputs update the active variant, change image, and update title/description
    document.querySelectorAll('.quickAdd input')?.forEach(el => {
        if (el.classList.contains('quickAddContentMainOptionsGroupSelectItemInput')) {
            el.addEventListener('change', function () {
                document.querySelectorAll('.quickAddContentVisualItem, .quickAddContentMainTopTitleItem,.quickAddContentMainDescriptionItem')?.forEach(el => {
                    el.dataset.variant === this.dataset.variant
                        ? el.classList.add('active')
                        : el.classList.remove('active');
                })
                // if there is a shipping delay, show
                document.querySelectorAll('.quickAddContentMainDelayItem')?.forEach(el => {
                    el.dataset.id === this.dataset.variant ? el.classList.add('active') : el.classList.remove('active');
                })
                // update atc button with new variant id
                document.querySelector('.quickAddContentMainPurchaseAtc').dataset.id = this.dataset.variant;
                // if pre-order item, update the button text
                document.querySelector('.quickAddContentMainPurchaseAtc').textContent = el.dataset.pre ? "PREORDER" : "ADD TO CART"
                // clear a disabled sold out state from the previous variant
                document.querySelector('.quickAddContentMainPurchaseAtc').disabled = false;
                // if sold out, hide the quantity elements and set the atc for notify
                if (el.dataset.soldOut) {
                    document.querySelector('.quickAddContentMainPurchase').classList.add('soldOut');
                    document.querySelector('.quickAddContentMainPurchaseAtc').textContent = "NOTIFY ME WHEN AVAILABLE";
                } else {
                    document.querySelector('.quickAddContentMainPurchase').classList.remove('soldOut');
                    document.querySelector('.quickAddContentMainPurchaseAtc').textContent = "ADD TO CART";
                }
                // variants marked to hide notify me get a disabled sold out button instead
                if (el.dataset.hideNotify) {
                    document.querySelector('.quickAddContentMainPurchaseAtc').disabled = true;
                    document.querySelector('.quickAddContentMainPurchaseAtc').textContent = "SOLD OUT";
                }

            })
        }
        if (el.classList.contains('quickAddContentMainSellingOptionInput')) {
            el.addEventListener('change', function () {
                // open select if subscription
                this.value === 'sub'
                    ? document.querySelector('.quickAddContentMainSellingPlan').classList.add('active')
                    : document.querySelector('.quickAddContentMainSellingPlan').classList.remove('active');
            })
        }
    })

    // quantity update
    document.querySelectorAll('.quickAddContentMainPurchaseQuantityButton')?.forEach(el => {
        el.addEventListener('click', function () {
            let quantity = parseInt(document.querySelector('.quickAddContentMainPurchaseAtc').dataset.quantity);
            if (this.classList.contains('quickAddContentMainPurchaseQuantityMinus')) {
                if (quantity <= 1) return;
                quantity--;
            } else {
                quantity++;
            }
            // update atc button with new quantity
            document.querySelector('.quickAddContentMainPurchaseAtc').dataset.quantity = String(quantity);
            // update quantity display
            document.querySelector('.quickAddContentMainPurchaseQuantityDisplay').textContent = String(quantity);
        })
    })

    // notify me dialog, this is destroyed everytime quick add is opened
    const notifyMeDialog = document.querySelector('.quickAddContentSoldOutDialog');
    notifyMeDialog.addEventListener('close', () => document.querySelector('body').classList.remove('noScroll'));
    notifyMeDialog.addEventListener('click', function (e) {
        if (e.target === this) this.close();
    })
    notifyMeDialog.querySelectorAll('.quickAddContentSoldOutDialogClose').forEach(el => {
        el.addEventListener('click', () => notifyMeDialog.close());
    })

    // submitting notify me
    document.querySelector('.quickAddContentSoldOutDialogForm').addEventListener('submit', function (e) {
        e.preventDefault();
        const variantId = this.querySelector('.quickAddContentSoldOutDialogFormVariant').value || null;
        const email = this.querySelector('.quickAddContentSoldOutDialogFormEmail').value || null;
        let phone = this.querySelector('.quickAddContentSoldOutDialogFormPhone').value || null;
        if (variantId && email) {
            document.querySelector('.quickAddContentSoldOutDialogFormButton').disabled = false;
            // format number if exists
            if (phone) {
                phone = formatPhoneNumberE164(phone)
            }
            // submit and offer confirmation message
            sendKlaviyoBackInStockRequest(email, variantId, phone).then(() => {
                document.querySelector('.quickAddContentSoldOutDialogInner').classList.add('active');
            }).catch(err => console.error(err));
        }
    })

    // atc button
    document.querySelector('.quickAddContentMainPurchaseAtc')?.addEventListener('click', async function () {

        // if sold item is currently selected, open notify me instead of atc
        // notify me button for not available variants
        if (this.closest('.quickAddContentMainPurchase').classList.contains('soldOut')) {
            document.querySelector('body').classList.add('noScroll');
            notifyMeDialog.showModal();
            return;
        }

        // add loading animation to both buttons
        this.classList.add("loading");

        let formData = {
            items: [{
                quantity: parseInt(this.dataset.quantity),
                id: parseInt(this.dataset.id),
            }]
        };

        // check for selling plan
        if (document.querySelector('.quickAddContentMainSellingOptionInput:checked')?.value === 'sub') {
            formData.items[0].selling_plan = parseInt(document.querySelector('.quickAddContentMainSellingPlanSelect').value);
        }

        // if pre-order, add property for cart
        if (document.querySelector('.quickAddContentMainOptionsGroupSelectItemInput:checked')?.dataset?.pre) {
            formData.items[0].properties = {
                _preorder: true
            };
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        // open cart
        await openCart();

        // close quick add modal
        document.querySelector('.quickAdd').close();
    })
}

// quick add buttons open the modal and load in proper product
// re-run on collection page
function quickAddButtons() {
    // atc buttons
    document.querySelectorAll('.collectionItemAtc')?.forEach((item) => {
        item.addEventListener('click', async function () {
            // fetch data using product or variant url
            const response = await fetch(`${this.dataset.url}${this.dataset.url.includes('?') ? "&" : "?"}sections=theme-quick-add`)
                .then(response => response.json());
            // create a new element and parse out contents
            const contentDiv = document.createElement('div');
            contentDiv.innerHTML = response["theme-quick-add"];
            // replace content with new product info
            document.querySelector('.quickAddContent').innerHTML = contentDiv.querySelector('.quickAddContent').innerHTML;
            // run the event listeners
            quickAddListeners();
            // open modal
            document.querySelector('body').classList.add('noScroll');
            document.querySelector('.quickAdd').showModal();
        })
    });

    // swatch/image or variant change
    document.querySelectorAll('.collectionItemBottomTypesItem')?.forEach(item => {
        item.addEventListener('click', function () {
            const parent = this.closest('.collectionItem');
            // update active variant on button and card link
            if (this.dataset.url) {
                parent.querySelector('.collectionItemAtc').dataset.url = this.dataset.url;
                parent.querySelector('.collectionItemLink').href = this.dataset.url;
            }
            // update active image
            if (this.dataset.value && parent.querySelector(`.collectionItemTopImage[data-value="${this.dataset.value}"]`)) {
                parent.querySelectorAll('.collectionItemTopImage').forEach(img => {
                    img.dataset.value === this.dataset.value ? img.classList.add('active') : img.classList.remove('active');
                })
            }
            // update mobile label
            if (this.dataset.value) {
                parent.querySelector('.collectionItemBottomLabel').textContent = this.dataset.value;
            }
            // change active status
            if (this.dataset.url || this.dataset.value) {
                parent.querySelectorAll('.collectionItemBottomTypesItem').forEach(item => item === this ? item.classList.add('active') : item.classList.remove('active'));
            }
        })
    });

    // update label on desktop and hover
    document.querySelectorAll('.collectionItemBottomTypesItem')?.forEach(item => {
        item.addEventListener('mouseover', function () {
            if (this.dataset.value) {
                this.closest('.collectionItemBottomTypes').querySelector('.collectionItemBottomTypesLabel').textContent = this.dataset.value;
            }
        })
        item.addEventListener('mouseleave', function () {
            this.closest('.collectionItemBottomTypes').querySelector('.collectionItemBottomTypesLabel').textContent = "";
        })
    });

    // check if there is a data-default-variant-title, if so, set that variant as active on load
    document.querySelectorAll('.collectionItem').forEach(item => {
        const defaultVariantTitle = item.dataset.defaultVariantTitle;
        if (defaultVariantTitle) {
            const variantItem = item.querySelector(`.collectionItemBottomTypesItem[data-value="${defaultVariantTitle}"]`);
            if (variantItem) {
                variantItem.click();
            }
        }
    });
}

// on load
quickAddButtons()